<template>
  <div class="c-post">
    <template v-if="!isExpired">
      <template v-if="!isAnswered || doAnswer">
        <div class="c-msg" v-html="formatMsg(post.content.main)"></div>
        <div>
          <v-radio-group
            v-model="data.situation"
            data-vv-name="situation"
            v-validate="'required'"
            :error-messages="getMessage('situation')"
            required
            :disabled="isGuest || loading"
            :mandatory="false"
            color="clr-primary"
          >
            <v-radio color="clr-primary" :label="toStatus(1)" value="1"></v-radio>
            <v-radio color="clr-primary" :label="toStatus(2)" value="2"></v-radio>
            <v-radio color="clr-primary" :label="toStatus(3)" value="3"></v-radio>
          </v-radio-group>
        </div>
        <div>
          <v-text-field
            counter="1000"
            data-vv-name="comment"
            v-validate="'max:1000'"
            :error-messages="getMessage('comment')"
            v-model="data.comment"
            color="clr-primary"
            name="comment"
            ref="comment"
            :disabled="isGuest || loading"
            :label="$T('attributes.comment')"
          ></v-text-field>
        </div>
        <div class="c-btn">
          <v-btn
            :loading="loading"
            :disabled="isGuest || loading"
            class="c-confirm-btn elevation-6"
            @click="onClicked"
            color="clr-btn"
            round
            dark
            depressed
          >
            <span>{{ $T('common.answer') }}</span>
          </v-btn>
        </div>
      </template>
      <template v-else-if="isAnswered">
        <div class="c-reans">
          <v-btn :disabled="isGuest" flat color="clr-primary" @click="doAnswer = true"
            ><v-icon left>mdi-pencil</v-icon>{{ $T('post.re-answer') }}</v-btn
          >
        </div>
      </template>
    </template>
    <div class="c-result">
      <div class="c-flex w100 ac">
        <div class="c-result-title s">{{ $T('common.answers') }}</div>
        <div v-if="!isGuest && !isExpired">
          <v-btn flat icon color="clr-black" :loading="answerLoading" @click="loadAnswer(post)">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </div>
      </div>
      <template v-if="answers && cms">
        <div v-if="answers.length == 0">{{ $T('common.no_data') }}</div>
        <v-list v-else class="c-list">
          <template v-for="(item, index) in sortedAnswers">
            <v-divider />
            <comment-tile :cmid="item.cmid" :cid="cid" :cms="cms" :c="toAnswer(item)" :t="item.answered_at" />
          </template>
          <v-divider />
        </v-list>
      </template>
    </div>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { answerPostLife } from '../../api/post';

export default {
  mixins: [postDetailPlugin],
  data() {
    return {
      loading: false,
      data: {
        situation: null,
        comment: null,
      },
      doAnswer: false,
    };
  },
  mounted() {
    this.loadAnswer(this.post);
  },
  watch: {
    post(n, o) {
      this.answeres = null;
      this.doAnswer = false;
      this.loadAnswer(n);
    },
    selfAnswer(n, o) {
      if (!n) return;
      this.data.situation = String(n.answer.a);
      this.data.comment = n.answer.c;
    },
  },
  computed: {
    sortedAnswers() {
      var as = this.answers;
      if (!as || as.length == 0) return [];

      as = as.concat();
      as.sort(function(a, b) {
        return a.answer.a == a.answer.b
          ? a.answered_at < b.answered_at
            ? -1
            : a.answered_at == b.answered_at
            ? a.cmid < b.cmid
              ? -1
              : 1
            : 1
          : a.answer.a < a.answer.b
          ? 1
          : -1;
      });
      return as;
    },
  },
  methods: {
    toStatus(status) {
      return CONST.postLifeStatus[status];
    },
    toAnswer(item) {
      var a = item.answer;
      var r = this.toStatus(a.a);
      return !!a.c ? `${r} - ${a.c}` : r;
    },
    fmtTime(item) {
      return this.diffDateFormatShort(this.$moment.unix(item.answered_at));
    },
    onClicked() {
      this.loading = true;
      var self = this;
      this.$validator.validateAll().then(result => {
        if (!result) return (self.loading = false);
        self.postData();
      });
    },
    postData() {
      if (this.isGuest) return;

      var d = this.data;
      var data = new FormData();
      data.append('pid', this.post.id);
      data.append('ans', d.situation);
      data.append('comment', cnvl(d.comment, ''));

      var self = this;
      answerPostLife(data)
        .then(function(post) {
          self.$emit('modified', post);
          self.post = post;
          self.doAnswer = false;
          self.loadAnswer(post);
          self.loading = false;
        })
        .catch(function(e) {
          console.error('failed to answer post data for pid[' + self.post.id + ']', e);
          self.errRegisterData();
          self.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.c-post {
  padding-bottom: 20px;
}
.c-reans {
  width: 100%;
  text-align: center;
}
.c-reans i {
  font-size: 20px;
}
.c-confirm-btn {
  min-width: 200px;
}
.c-btn {
  text-align: center;
  padding: 25px 0 30px 0;
}
.le-tbs .c-btn {
  padding: 15px 0 30px 0;
}
.c-result-title {
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  font-size: 16px;
}
.c-list {
  overflow-x: hidden;
}
</style>
